export default {
  USER_ID: `IZ8PtKdq3cdyfK2mb`,
  TEMPLATE_ID: `template_h6avlap`,
};
